// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"Z2-z","inlineTitle":"_2-z","sponsoredAdsWrapper":"a3-z","marketplaceRecosWrapper":"b3-z","brandShopTheLookWrapper":"c3-z"};